/**
 * Count filter fields with a non-empty value (for Filters badge).
 * @param {Record<string, unknown>} current
 * @param {Record<string, unknown>} [_defaults] Kept for call-site compatibility; not used for counting.
 */
export function countActivePageFilters(current, _defaults) {
  return countFilledPageFilters(current);
}

/** @param {Record<string, unknown>} current */
export function countFilledPageFilters(current) {
  if (!current || typeof current !== "object") return 0;

  return Object.keys(current).reduce((count, key) => {
    if (isFilterValueFilled(current[key])) {
      return count + 1;
    }
    return count;
  }, 0);
}

/** Badge displays only when 2+ filter fields are filled */
export function getFilterBadgeCount(activeCount) {
  const count = Number(activeCount) || 0;
  return count >= 2 ? count : 0;
}

function isFilterValueFilled(value) {
  if (value == null || value === "") return false;

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (value instanceof Date) {
    return !Number.isNaN(value.getTime());
  }

  if (typeof value === "string") {
    return value.trim().length > 0;
  }

  return true;
}
